/* ONECART ライブ新着フィード（featured-collection「新品上市」）。
   バッファ描画した実商品をキューとして、一定間隔で:
     1) 左上に次の新着を差し込む（フェード＋スライドイン）
     2) 既存カードは FLIP で1つずつ滑らかにズレる
     3) 右下のカードはフェード退場 → キュー末尾へ回収（ループ）
   ホバー/フォーカス・タブ非表示・prefers-reduced-motion で停止。 */
(function () {
  'use strict';
  var DUR = 480; // FLIP/差し込みの所要(ms)
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(grid) {
    if (grid.dataset.ocFeedInit) return;
    grid.dataset.ocFeedInit = '1';

    var WIN = parseInt(grid.getAttribute('data-window'), 10) || 0;
    var interval = (parseInt(grid.getAttribute('data-interval'), 10) || 5) * 1000;
    var items = function () { return Array.prototype.slice.call(grid.querySelectorAll(':scope > [data-oc-feed-item]')); };

    var all = items();
    if (reduce || all.length <= WIN || WIN < 2) return; // バッファ無し/低モーションは静止のまま

    var paused = false;
    var animating = false;

    function preload(el) {
      if (!el) return;
      var img = el.querySelector('img');
      if (!img) return;
      var pre = new Image();
      if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
      if (img.getAttribute('src')) pre.src = img.getAttribute('src');
    }
    // 次に差し込む控えの画像を先読み（display:none のままだと読まれないため）
    preload(all[WIN]);

    function tick() {
      if (paused || animating || document.hidden) return;
      var list = items();
      var visible = list.slice(0, WIN);
      var next = list[WIN];
      if (!next || visible.length < WIN) return;
      var drop = visible[visible.length - 1];

      animating = true;

      // 1) 移動前の位置を記録（継続カード＝退場カードを除く）
      var keep = visible.slice(0, WIN - 1);
      var firstRects = keep.map(function (el) { return el.getBoundingClientRect(); });

      // 2) 退場カードを絶対配置で流れから外す（グリッドは窓数のまま保たれる）
      var gridRect = grid.getBoundingClientRect();
      var dr = drop.getBoundingClientRect();
      drop.classList.add('oc-feed--exiting');
      drop.style.position = 'absolute';
      drop.style.margin = '0';
      drop.style.top = (dr.top - gridRect.top + grid.scrollTop) + 'px';
      drop.style.left = (dr.left - gridRect.left) + 'px';
      drop.style.width = dr.width + 'px';
      drop.style.height = dr.height + 'px';

      // 3) 次の新着を先頭へ差し込み（初期状態＝少し上・縮小・透明）
      grid.insertBefore(next, grid.firstChild);
      next.classList.remove('oc-feed--queued');
      next.style.transition = 'none';
      next.style.transform = 'translateY(-14px) scale(0.96)';
      next.style.opacity = '0';

      // 4) 継続カードを FLIP（新位置との差分だけ逆オフセット）
      var inverts = keep.map(function (el, i) {
        var nr = el.getBoundingClientRect();
        var dx = firstRects[i].left - nr.left;
        var dy = firstRects[i].top - nr.top;
        el.style.transition = 'none';
        el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
        return el;
      });

      // 5) 次フレームで再生（transform を 0 へ＝本来の位置／状態へ動かす）
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var ease = 'cubic-bezier(.22,.61,.36,1)';
          inverts.forEach(function (el) {
            el.style.transition = 'transform ' + DUR + 'ms ' + ease;
            el.style.transform = 'translate(0,0)';
          });
          next.style.transition = 'transform ' + DUR + 'ms ' + ease + ', opacity ' + DUR + 'ms ease';
          next.style.transform = 'translateY(0) scale(1)';
          next.style.opacity = '1';
          drop.style.transition = 'transform ' + DUR + 'ms ' + ease + ', opacity ' + DUR + 'ms ease';
          drop.style.transform = 'scale(0.9)';
          drop.style.opacity = '0';
        });
      });

      // 6) 後始末＝インライン除去・退場カードをキュー末尾へ回収
      setTimeout(function () {
        keep.forEach(function (el) { el.style.transition = ''; el.style.transform = ''; });
        next.style.transition = ''; next.style.transform = ''; next.style.opacity = '';
        drop.classList.remove('oc-feed--exiting');
        drop.removeAttribute('style');
        drop.classList.add('oc-feed--queued');
        grid.appendChild(drop);
        preload(items()[WIN]); // 次の控えを先読み
        animating = false;
      }, DUR + 60);
    }

    var timer = setInterval(tick, interval);

    // 停止条件：ホバー/フォーカス
    grid.addEventListener('mouseenter', function () { paused = true; });
    grid.addEventListener('mouseleave', function () { paused = false; });
    grid.addEventListener('focusin', function () { paused = true; });
    grid.addEventListener('focusout', function () { paused = false; });

    // テーマエディタで section が消えたら timer 解放
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains(grid)) clearInterval(timer);
    });
  }

  function boot() {
    document.querySelectorAll('[data-oc-livefeed]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // テーマエディタで section 再描画時にも初期化
  document.addEventListener('shopify:section:load', boot);
})();
